import React from 'react';
import './Pokerwatch_new.css';
import DataTable from '../common/Table/index';
import Grid from '@material-ui/core/Grid';
import $ from 'jquery';
import moment from 'moment';
import { InputDatePicker } from 'mygame-components';
import MediaQuery from 'react-responsive';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Suggestions from './Suggestions';
import CustomisedDialog from './CustomisedDialog';
import { Checkbox } from '@material-ui/core';
import CheckedIcon from 'material-ui/svg-icons/toggle/check-box';
import CheckBoxOutlineBlankIcon from "material-ui/svg-icons/toggle/check-box-outline-blank";
import AssignPlayerIcon from '../../img/assign.png';
import UserIcon from '../../img/addexistingplayer.png';
import VisibilitySensor from 'react-visibility-sensor';
import CurrentFilter from './CurrentFilter';
import { saveActivity } from '../../common/commonService';

const NoActivity = (props) => {
    return <div className='no-activity-div' style={props.customStyle ? { marginTop: props.customStyle.marginTop } : {}} > <span className='no-activity-header'>No Activity</span>
        <span className='no-activity-description'> Try <span style={{ color: 'red' }}>filters <i className="fa fa-filter" > </i></span> to find what you're looking for.</span>
    </div>
}
const PlayerSuggestions = (props) => {
    //console.log('PlayerSuggestions props', props)
    const { actionPerform } = props;
    let options = props.results.map((r, _id) => (
        <button key={_id} className="player-suggestions-button" onClick={(e) => actionPerform(e, r.playerDetails['accountName'])}><span className='player-suggestions-button-text'>{r.playerDetails['accountName']}</span></button>
    ))
    return <div className="player-suggestions-postion" style={{ width: props.styles ? props.styles.width : '', marginTop: props.styles ? props.styles.marginTop : '' }}>
        {options}</div>
}

const ChangeOwner = props => {
    //console.log('****', props);
    return <div className="poker-watch-create-team-div">
        <span className="input-lable"> Current Stable Owner </span>
        <input type="text" className="poker-watch-create-team-text" placeholder="The A Stable" data-e2e="team-name"
            value={props.teamData.ownerName}></input>
        {props.isTeamAlreadyExist > 0 ? <span className="create-stable-owner-lable">Team Name should be unique in a Stable</span> : ''}
        <span className="input-lable">Assign Stable Owner</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="Eg: John Doe" data-e2e="team-name"
            onChange={(event) => { props.handleInputChange(event, { "type": "ownerDetails", "inputObj": { "name": event.target.value } }) }} value={props.creatTeamObj.name}></input>
        {props.isOwnerAlreadyExist > 0 ? <span className="create-stable-owner-lable">Stable Name should be unique</span> : ''}
        {props.coachDetails && props.coachDetails.length > 0 ? <Suggestions data={props.coachDetails} actionPerform={props.action} elemClass={'stable-owner-suggestion'} /> : ''}
        <span className="create-stable-owner-lable" onClick={e => props.updateObject('owner')} style={{ cursor: 'pointer' }} > Or create new Stable Owner</span><br />
        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
    </div>
}
const ChangeCoach = props => {
    //console.log('****', props);
    return <div className="poker-watch-create-team-div">
        <span className="input-lable"> Current coach </span>
        <input type="text" className="poker-watch-create-team-text" placeholder="The A Stable" data-e2e="team-name"
            value={props.currentSubTeamObj.coachName}></input>
        <span className="input-lable">New Coach</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="Eg: John Doe" data-e2e="team-name"
            value={props.creatTeamObj.name} onChange={(event) => { props.handleInputChange(event, { "type": "coachDetails", "inputObj": { "name": event.target.value } }) }} value={props.creatTeamObj.name}></input>
        {props.isOwnerAlreadyExist > 0 ? <span className="create-stable-owner-lable">Coach Already  Assinged to a team in another Stable </span> : ''}
        {props.coachDetails && props.coachDetails.length > 0 ? <Suggestions data={props.coachDetails} actionPerform={props.action} elemClass={'stable-owner-suggestion'} /> : ''}
        <span className="create-stable-owner-lable" onClick={e => props.updateObject('coachUpdate')} style={{ cursor: 'pointer' }}> Or create new coach</span><br />
        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
    </div>
}
const UpdateTeam = props => {
    //console.log('****', props);
    return <div className="poker-watch-create-team-div">
        <span className="input-lable">Current Team Name</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="The A Team" data-e2e="team-name"
            value={props.currentSubTeam}></input>
        <span className="input-lable">New Team Name</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="The A Team" data-e2e="team-name"
            onChange={e => { props.verifyUnique(e, props.teamData.teamName) }}></input>
        {props.isTeamAlreadyExist > 0 ? <span className="create-stable-owner-lable" >Team Name should be unique in a Stable</span> : ''}
        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
    </div>
}
const CreateTeam = props => {
    //console.log('****', props);
    return <div className="poker-watch-create-team-div">
        <span className="input-lable">Create Team Name</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="The A Team" data-e2e="team-name"
            onChange={e => { props.verifyUnique(e, props.teamData.teamName) }}></input>
        {props.isTeamAlreadyExist > 0 ? <span className="create-stable-owner-lable" >Team Name should be unique in a Stable</span> : ''}
        <span className="input-lable">Assing Existing Coach</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="Eg: John Doe" data-e2e="team-name"
            value={props.creatTeamObj.name} onChange={(event) => { props.handleInputChange(event, { "type": "coachDetails", "inputObj": { "name": event.target.value } }) }} value={props.creatTeamObj.name}></input>
        {props.isOwnerAlreadyExist > 0 ? <span className="create-stable-owner-lable">Coach Already  Assinged to a team in another Stable </span> : ''}
        {props.coachDetails && props.coachDetails.length > 0 ? <Suggestions data={props.coachDetails} actionPerform={props.action} elemClass={'stable-owner-suggestion'} /> : ''}
        <span className="create-stable-owner-lable" onClick={e => props.updateObject('coach')} style={{ cursor: 'pointer' }}> Or create new coach</span><br />
        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
    </div>
}
const CreateOwner = props => {
    return <div className="poker-watch-create-team-div">
        <span className="input-lable">User Email</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="example@gmail.com" data-e2e="team-name" onBlur={(event) => { props.handleInputChange(event, { "type": props.type ? props.type : "coachDetails", "inputObj": { "email": event.target.value } }) }}></input>
        {props.errorOBj.emailError && <span className="create-stable-owner-lable">{props.errorOBj.emailError}</span>}
        <span className="input-lable">Full Name</span>
        <input type="text" className="poker-watch-create-team-text" placeholder="Eg: John Doe" data-e2e="team-name"
            onBlur={(event) => { props.handleInputChange(event, { "type": props.type ? props.type : "coachDetails", "inputObj": { "fullName": event.target.value, "name": event.target.value } }) }}></input>
        {props.errorOBj.fullNameError && <span className="create-stable-owner-lable">{props.errorOBj.fullNameError}</span>}
        <span className="input-lable">User Password</span>
        <input type="password" className="poker-watch-create-team-text" placeholder="************" data-e2e="team-name"
            onChange={(event) => { props.handleInputChange(event, { "type": "password", "inputObj": { "password": event.target.value } }) }}></input>

        {props.errorOBj.createTeamError ? <span className="create-stable-owner-lable">{props.errorOBj.createTeamError}</span> : ''}
    </div>
}
const OwnerMobileStatsPage = props => {
    const { enableComponent, filterEnable, openDialogBox, selectedData, subMenuEnable, currentSubTeam } = props
    return <div>
        {filterEnable ? <FilterGrid {...props}></FilterGrid> :
            <div className="pw-filter-mobile-view">
                <span className="pw-filter-mobile-setting-span"> Stable Settings</span> <i className="fa fa-lg fa-times" style={{ float: 'right', marginRight: '1rem' }} onClick={() => enableComponent('moreEnable')}></i>
                <div className="pw-filter-mobile-view-div">
                    <span onClick={e => enableComponent('filterEnable', true)}>Filters</span>
                    <span onClick={e => openDialogBox('addUser', 'addUser', true)}>Add User(s)</span>
                    <span onClick={e => openDialogBox('changeOwner', 'changeOwner', true)} >Change Stable Owner</span>
                    <span onClick={e => openDialogBox('createNewTeam', 'createNewTeam', true)}>Create New Team</span>
                    <span onClick={e => openDialogBox('coachCreationModal', 'coachCreationModal',true)}> Create Coach </span>
                </div>
                {selectedData && selectedData.length > 0 && (currentSubTeam === '' || subMenuEnable) ? <div className="pw-filter-mobile-selected-view-div">
                    <span onClick={e => openDialogBox('enableStats', 'statsUpdate', true)}>Enable Stats</span>
                    <span onClick={e => openDialogBox('disableStats', 'statsUpdate', true)}>Disable Stats</span>
                    <span data-toggle="modal" data-target="#downloadModal" onClick={() => {
                        let track = {}
                        track.hit_page = 'ExportHandsPopup';
                        track.hit_type = 'OpenModal';
                        track.hit_attribute1 = props.teamData ? props.teamData.teamName : props.teamData.name;
                        track.hit_player = "admin";
                        saveActivity(track);
                    }}
                    >Download Hands</span>
                    <span onClick={e => openDialogBox('assingPlayer', 'assingPlayer', true)}>Assign selected Players(s)</span>
                    <span onClick={e => openDialogBox('deletePlayer', 'deletePlayer', true)}>Remove from Stable </span>
                </div> : ''
                }
            </div>}
    </div>
}
const CoachMobileStatsPage = props => {

    const { enableComponent, filterEnable, openDialogBox, selectedData } = props
    return <div>
        {filterEnable ? <FilterGrid {...props}></FilterGrid> :
            <div className="pw-filter-mobile-view">
                <span className="pw-filter-mobile-setting-span"> Team Settings</span> <i className="fa fa-lg fa-times" style={{ float: 'right', marginRight: '1rem' }} onClick={() => enableComponent('subMenuEnable')}></i>
                <div className="pw-filter-mobile-view-div">
                    <span onClick={e => openDialogBox('editTeam', 'editTeam', true)}>Edit Team Name</span>
                    <span onClick={e => openDialogBox('changeCoach', 'changeCoach', true)}>Change Coach</span>
                    <span onClick={e => openDialogBox('addPlayer', 'addPlayer', true)} >Add Player(s)</span>
                    <span onClick={e => openDialogBox('deleteTeam', 'deleteTeam', true)}>Delete Team</span>
                </div>
                {selectedData && selectedData.length > 0 ? <div className="pw-filter-mobile-selected-view-div">
                    <span onClick={e => openDialogBox('enableStats', 'statsUpdate', true)}>Enable Stats</span>
                    <span onClick={e => openDialogBox('disableStats', 'statsUpdate', true)}>Disable Stats</span>
                    <span data-toggle="modal" data-target="#downloadModal" onClick={() => {
                        let track = {}
                        track.hit_page = 'ExportHandsPopup';
                        track.hit_type = 'OpenModal';
                        track.hit_attribute1 = props.teamData ? props.teamData.teamName : props.teamData.name;
                        track.hit_player = "admin";
                        saveActivity(track);
                    }}
                    >Download Hands</span>
                    <span onClick={e => openDialogBox('assingPlayer', 'assingPlayer', true)}>Assign selected Players(s)</span>
                    <span onClick={e => openDialogBox('deletePlayer', 'deletePlayer', true)}>Remove from Team </span>
                </div> : ''
                }
            </div>}
    </div>
}
const MobileStatsDetails = props => {
    const { moreEnable, subMenuEnable } = props

    return <div>
        {moreEnable ? <OwnerMobileStatsPage {...props} /> : subMenuEnable ? <CoachMobileStatsPage {...props} /> : ''}
    </div>
}
const StatsDetails = props => {
    //console.log('statsDetails', props);
    let { currentSubTeam, enableComponent, openFileListModal, menuEnable, openDialogBox, dialogContent,
        addPlayerToList, selectedData, statsUpdate, bussinessOwnerStatus, isCoach, filterEnable } = props;

    return (
        // style={deletePlyrData && deletePlyrData.length > 0 ? { paddingLeft: '28rem' } : { paddingLeft: '48rem' }}
        <div>
            {/* <ClickAwayListener onClickAway={() => enableComponent('', false)}> */}
            <div className="pokerwatch-team-center" style={{ paddingLeft: (selectedData && selectedData.length > 0 && !currentSubTeam) ? bussinessOwnerStatus ? '4rem' : '9rem' : isCoach ? '35rem' : '25rem', marginTop: isCoach ? '-5px' : '10px' }}>
                {!isCoach && (!currentSubTeam) && selectedData && selectedData.length > 0 ? <span>
                    {bussinessOwnerStatus ? <i className="fa fa-lg fa-user-times" title = "Delete Users" onClick={(e) => openDialogBox('deletePlayer')} ></i> : ''}
                    <ClickAwayListener onClickAway={() => statsUpdate ? enableComponent('', false) : ''}>
                        <div style={{ display: 'inline' }}><i className="fa fa-chart-bar fa-lg chart-bar-icon" title = "Stats" onClick={() => enableComponent('statsUpdate', true)}></i>
                            {statsUpdate ? <div className="stats-update-div" style={{ marginLeft: '-3.2rem',paddingLeft:'0rem' }} >

                                <button className="stats-button-on-off" onClick={(e) => openDialogBox('enableStats', 'statsUpdate')} style={{ marginBottom: '5px' }}>Enable Stats</button>

                                <button className="stats-button-on-off" onClick={(e) => openDialogBox('disableStats', 'statsUpdate')}>Disabe Stats</button>

                            </div> : ''}</div>
                    </ClickAwayListener>
                    <i onClick={(e) => openDialogBox('assingPlayer')} title = "Assign" > <img src={AssignPlayerIcon} alt="AssignPlayer" height='18px' style={{ marginRight: '2rem', marginTop: '-4px' }} /> </i>
                    <i className="fa fa-lg fa-download" title = "Download Hands" data-toggle="modal" data-target="#downloadModal" onClick={() => {
                        let track = {}
                        track.hit_page = 'Stable';
                        track.hit_type = 'StableDownloadHands';
                        track.hit_attribute1 = props.teamData ? props.teamData.teamName : props.teamData.name;
                        saveActivity(track);
                        enableComponent('', false)
                    }}></i>

                </span> : ''}
                <ClickAwayListener onClickAway={() => menuEnable ? enableComponent('', false) : ''}>
                    <div style={{ display: 'inline' }}>
                        {!isCoach ? <i className="fa fa-lg fa-plus-square" title = "Settings" onClick={() => enableComponent('menuEnable', true)} ></i>
                            : ''}
                        {menuEnable ?

                            <div className="pw-team-body-menu" style={{ marginLeft: (!currentSubTeam) && selectedData && selectedData.length > 0 ? bussinessOwnerStatus ? '4rem' : '0rem' : '-15.2rem', height: !bussinessOwnerStatus ? '8rem' : '14.5rem' }} >

                                {bussinessOwnerStatus ?
                                    <button onClick={e => openDialogBox('addUser', 'menuEnable')} > Add user(s) </button>
                                    : ''}
                                {bussinessOwnerStatus ?
                                    <button onClick={e => openDialogBox('changeOwner', 'menuEnable')} > Change Owner </button>
                                    : ''}

                                <button onClick={e => openDialogBox('createNewTeam', 'menuEnable')}> Create new team </button>
                                <button onClick={e => openDialogBox('coachCreationModal', 'menuEnable')}> Create Coach </button>

                            </div>


                            : ''}
                    </div>
                </ClickAwayListener>

                {!isCoach ? <div style={{ display: 'inline' }}><i className="fa fa-file-alt fa-lg upload-file-icon"  title = "Files" onClick={() => openFileListModal()}></i>
                    {}</div> : ''}
                {filterEnable ? <i className="fa fa-lg fa-times" style={{ marginRight: '0px', width: '10px' }} onClick={() => enableComponent('filterEnable')}></i>
                    : <i className="fa fa-lg fa-filter" title = "Filters" style={{ marginRight: '0px', width: '10px' }} data-e2e="filter-game" onClick={() => enableComponent('filterEnable')}></i>}


                {dialogContent && dialogContent.isDialogOpen && <CustomisedDialog {...dialogContent}>
                    {dialogContent.dataType === 'addUser' ? <AddUser {...props} actionPerform={addPlayerToList} /> : dialogContent.dataType === 'ownerCreationModal' ?
                        <CreateOwner {...props} type={'owner'} actionPerform={addPlayerToList}></CreateOwner> : dialogContent.dataType === 'createNewTeam' ?
                            <CreateTeam {...props} actionPerform={addPlayerToList}></CreateTeam> : dialogContent.dataType === 'changeOwner' ?
                                <ChangeOwner {...props} actionPerform={addPlayerToList}></ChangeOwner> : dialogContent.dataType === 'changeCoach' ?
                                    <ChangeCoach {...props} actionPerform={addPlayerToList}></ChangeCoach> : dialogContent.dataType === 'editTeam' ?
                                        <UpdateTeam {...props} actionPerform={addPlayerToList}></UpdateTeam> : dialogContent.dataType === 'addPlayer' ?
                                            <AddPlayerToSubTeam  {...props} actionPerform={addPlayerToList}></AddPlayerToSubTeam> : dialogContent.dataType === 'deletePlayer' ?
                                                <p className="pokerwatch-dialog-common">Would you like to remove selected player(s) from the team?</p> : dialogContent.dataType === 'assingPlayer' ?
                                                    <AssignPlayerToTeam {...props}></AssignPlayerToTeam> : dialogContent.dataType === 'coachCreationModal' || dialogContent.dataType === 'coachCreationModalUpdate' ?
                                                        <CreateOwner {...props} actionPerform={addPlayerToList}></CreateOwner> : dialogContent.dataType === 'deleteTeam' ?
                                                            <p className="pokerwatch-dialog-common">Would you like to delete selected team ?</p> : dialogContent.dataType === 'enableStats' ?
                                                                <p className="pokerwatch-dialog-common">Would you like to make visible P&L, Rake and EV for the selected players ?</p> : dialogContent.dataType === 'disableStats' ?
                                                                    <p className="pokerwatch-dialog-common">Would you like to hide P&L, Rake and EV for the selected players ?</p> : ''
                    }
                </CustomisedDialog>}

            </div>
            {/* </ClickAwayListener> */}
        </div>)

}
const GameType = (props) => {
    const { handleGameType, gameType } = props;
    return <div>
        <label htmlFor="select1" className="period_select_lable" >GAME TYPE</label>
        <select className="form-control2 pokerwatch-team-filet-select" data-e2e="game-type" onChange={handleGameType} value={gameType}>
            <option value="cash">Cash Games</option>
            <option value="tournament">MTT</option>
            <option value="Spin">Spins</option>
        </select>
    </div>
}
const FromDate = (props) => {
    const { dateError, downloadFrom, showFromDatePicker, selectedFromDate, handleChange, handleSave, updatePosition } = props
    return <div>
        <div className="dp_date_picker_group" id="pw_dp_date_picker_group1" data-toggle="modal"
            data-target="#pWdpFromDateTimePicker">
            <div className="dp_lable">
                FROM: <span className="date-error">{dateError && dateError.fromDate ? dateError.fromDate : ''}</span>
            </div>
            <div className="pw_team_selector_dropdown" onClick={() => updatePosition(true)} >
                <span className="pw_team_datepicker_text" data-e2e="from-date">

                    {(showFromDatePicker) ? moment(downloadFrom).format("DD/MM/YYYY - hh:mmA") : <spam>DD/MM/YYYY{<span style={{ marginLeft: "5px", marginRight: "5px" }}>&#8212;</span>}HH/MM</spam>}
                </span>
            </div>
            {/* <ClickAwayListener onClickAway={()=>{
            $('#pw_dp_date_picker_group1').length>0?$('#pw_dp_date_picker_group1').click():''
        }}> */}
        </div>
        <InputDatePicker modalId="pWdpFromDateTimePicker" selectedDate={selectedFromDate}
            handleChange={(data) => { handleChange(data, "selectedFromDate") }}
            handleSave={() => {
                handleSave("downloadFrom", "showFromDatePicker");
                $('#pw_dp_date_picker_group1').click();
                updatePosition(false);
            }}
        />
        {/* </ClickAwayListener> */}
    </div>
}
const ToDate = (props) => {
    const { dateError, selectTo, showToDatePicker, selectedToDate, handleChange, handleSave, updatePosition } = props
    return <div><div className="dp_date_picker_group" id="pw_dp_date_picker_group2" data-toggle="modal"
        data-target="#pWdpToDateTimePicker">
        <div className="dp_lable">
            TO:<span className="date-error">{dateError && dateError.toDate ? dateError.toDate : ''}</span>
        </div>
        <div className="pw_team_selector_dropdown" onClick={() => updatePosition(true)}>
            <span className="pw_team_datepicker_text" data-e2e="to-date" >
                {(showToDatePicker) ? moment(selectTo).format("DD/MM/YYYY - hh:mmA") : <spam>DD/MM/YYYY{<span style={{ marginLeft: "5px", marginRight: "5px" }}>&#8212;</span>}HH/MM</spam>}
            </span>

        </div>
    </div>
        <InputDatePicker
            modalId="pWdpToDateTimePicker"
            selectedDate={selectedToDate}
            handleChange={(data) => { handleChange(data, "selectedToDate") }}
            handleSave={() => {
                handleSave("selectTo", 'showToDatePicker');
                $('#pw_dp_date_picker_group2').click();
                updatePosition(false);
            }}
        />
    </div>
}
const PlayerActivity = props => {
    const { handlePlayerActivity, playerActivity } = props
    return <div className="period_select_div">
        <label htmlFor="select1" className="period_select_lable" >PLAYER ACTIVITY</label>
        <select className="form-control2 pokerwatch-team-filet-select" data-e2e="player-activity" onChange={handlePlayerActivity} value={playerActivity}>
            <option value="1">Played</option>
            <option value="0">Not Played</option>
            <option value="2">All</option>
        </select>

    </div>
}
const PlayerSearch = props => {
    const { playerNameDataByTeam, getPlayerDetailsByTeamNameAndName, searchPlayerDetailsOnEnter, handleSearch, stateChange } = props
    return <div>
        <label className="search_player_lable" >PLAYER NAME</label>
        <input className="search-player" data-e2e="player-name" type="text" placeholder="Search Player "
            onChange={getPlayerDetailsByTeamNameAndName} onKeyPress={e => searchPlayerDetailsOnEnter(e, playerNameDataByTeam[0] !== undefined ? playerNameDataByTeam[0].players : '')} />
        <button className="poker-watch-create-player-search-button"><i className="fa fa-search search-icon" data-e2e="player-search" onClick={() => handleSearch(playerNameDataByTeam[0] !== undefined ? playerNameDataByTeam[0].players : '')}></i></button>
        {playerNameDataByTeam.length !== 0 ? <PlayerSuggestions results={playerNameDataByTeam[0].showPlayers} actionPerform={stateChange} styles={{ marginTop: window.innerWidth <= 1024 ? '-2.5rem' : '-2.5rem', width: '28rem' }} /> : ''}

    </div>
}
const TeamSelect = props => {
    const { currentSubTeamObj, switchTeam, subTeam } = props;
    let subTeamOptions = subTeam.map((data) => <option key={data.teamName ? data.teamName : data.name}
        value={data.teamName ? data.teamName : data.name}>
        {data.teamName ? data.teamName : data.name}
    </option>
    );
    return <div className="period_select_div">
        <label htmlFor="select1" className="period_select_lable" >TEAMS</label>
        <select className="form-control2 pokerwatch-team-filet-select" data-e2e="all-team" onClick={(e) => {
            e.preventDefault();
            let track = {}
            track.hit_page = 'Stable';
            track.hit_type = 'StableViewTeams';
            track.hit_attribute1 = props.teamData ? props.teamData.teamName : props.teamData.name;
            saveActivity(track);
        }} onChange={switchTeam} value={currentSubTeamObj.teamName ? currentSubTeamObj.teamName : 'all'}>
            <option value="all">Show All Team</option>
            {subTeamOptions}
        </select>
    </div>
}
const SortBy = props => {
    const { sortOn, handleSort } = props
    return <div className="period_select_div">
        <label htmlFor="select1" className="period_select_lable" >SORT BY</label>
        <select className="form-control2 pokerwatch-team-filet-select" data-e2e="player-activity" onChange={e => handleSort(e, e.target.value)} value={sortOn ? sortOn : 'lastHandPlayer'}>
            <option value="playerName">Player Name</option>
            {/* <option value="statsVisibleIcon">Stats</option> */}
            <option value="noOfGame">Game</option>
            <option value="rake">Rake</option>
            <option value="lastHandPlayer">Last Hand</option>
        </select>

    </div>
}
const FilterGrid = props => {
    const { position } = props;
    console.log('props*****', props)
    return (
        <MediaQuery minWidth={1025}>
            {(matches) => {
                if (matches) {
                    return <div className="pokerwatch-team-filter">
                        <div className="pokerwatch-team-filter-div" style={position ? { position: 'inherit' } : { position: 'fixed' }}>
                            <Grid container spacing={24} >
                                <Grid item xs={6} sm={3}> <GameType {...props} data-e2e="game-type" /> </Grid>
                                <Grid item xs={6} sm={3}> <FromDate {...props} />  </Grid>
                                <Grid item xs={6} sm={3}> <ToDate {...props} />  </Grid>
                                <Grid item xs={6} sm={3}> <PlayerActivity {...props} /> </Grid>
                                <Grid item xs={6} sm={3} style={{ marginTop: '-3rem' }}> <PlayerSearch {...props} /> </Grid>
                                <Grid item xs={6} sm={3} style={{ marginTop: '-3rem' }}> <TeamSelect {...props} /> </Grid>
                            </Grid>
                        </div>
                    </div>
                }
                else {
                    const { enableComponent, subMenuEnable, showResults } = props;

                    return <div className="pokerwatch-team-filter-mobile"><Grid container spacing={24}>
                        <Grid item xs={12}><span className="pw-filter-mobile-setting-span"> Filters </span>
                            <i className="fa fa-lg fa-times" style={{ float: 'right', marginRight: '1rem' }} onClick={() => enableComponent(subMenuEnable ? 'subMenuEnable' : 'moreEnable', false, true)}></i>
                        </Grid>
                        <Grid item xs={12}> <GameType {...props} /> </Grid>
                        <Grid item xs={12}> <FromDate {...props} /> </Grid>
                        <Grid item xs={12}> <ToDate {...props} /> </Grid>
                        <Grid item xs={12}> <PlayerActivity {...props} /> </Grid>
                        <Grid item xs={12}> <TeamSelect {...props} /> </Grid>
                        <Grid item xs={12}> <SortBy {...props} /> </Grid>
                        <Grid item xs={12}> <PlayerSearch {...props} /> </Grid>
                        {showResults && <Grid item xs={12} ><div className='show-results-div'><button className='show-results-mobile' onClick={() => enableComponent('moreEnable')}>SHOW RESULTS</button> </div></Grid>}
                    </Grid>
                    </div>
                }
            }}
        </MediaQuery>
    )
}
const HeaderDetails = props => {
    const { teamData, NumberFormatter, currentSubTeam, isCoach, filterStatusObj } = props;
    //console.log('props', props);
    return (
        <div className='container' >
            <Grid container spacing={24} style={{
                marginTop: '-5px',
                width: '125rem',
                paddingTop: isCoach ? '30px' : '15px',
            }}>
                <Grid item xs={8}>
                    <Grid container spacing={24} >

                        <Grid item xs style={{ marginTop: '0px', padding: '0px' }}>
                            <span className="pokerwatch-admin-stable-name">{teamData !== undefined ? teamData.teamName ? teamData.teamName + ' - ' : teamData.name ? teamData.name:' NA' + ' - ' : 'NA'}<span style={{ fontWeight: '400' }}>{' Stable Owner: '}  {teamData !== undefined ? teamData.ownerName : ''}</span></span><br />
                        </Grid>
                    </Grid>

                    {!isCoach ? <Grid container spacing={24} style={{ marginTop: '8px' }}>
                        <Grid item xs>
                            {currentSubTeam ? <i className="fa fa-filter" style={{ marginRight: '0px', color: 'red' }}> <span style={{ fontFamily: 'Roboto', fontSize: '12px' }}>Team Filter Applied</span></i> :
                                <div className="pokerwatch-team-stats-details">
                                    <span>Games Played: {teamData !== undefined ? NumberFormatter(teamData.noOfGames) : 0}</span>
                                    <span>
                                        P&L: {(teamData !== undefined && teamData.profitOrLoss > 0) ? "+" : ""}{teamData !== undefined ? NumberFormatter(teamData.profitOrLoss) : 0}
                                    </span>
                                    <span>Rake: {teamData !== undefined ? NumberFormatter(teamData.totalRake) : 0}</span>
                                    <span>Win Rate: {teamData !== undefined ? NumberFormatter(teamData.winRate) : 'winRate'} </span>
                                    <span>EV: {teamData !== undefined ? NumberFormatter(teamData.ev) : 'ev'}</span>
                                    <span>EV Diff: {teamData !== undefined ? NumberFormatter(teamData.evDiff) : 'evDiff'}</span>
                                </div>}
                        </Grid>
                    </Grid> : ''}
                </Grid>
                <Grid item xs={4}>
                    <StatsDetails {...props}></StatsDetails>
                </Grid>
                <CurrentFilter filterStatusObj={filterStatusObj} />
            </Grid>
        </div>
    )
}
const AssignPlayerToTeam = props => {
    const { subTeam, currentSubTeamObj, updatedSubTeam, handleAssignTeam } = props;
    let options = subTeam.map((data) => <option key={data.teamName ? data.teamName : data.name}
        value={data.teamName ? data.teamName : data.name}>
        {data.teamName ? data.teamName : data.name}
    </option>
    );
    return <div className="pokerwatch-dialog-common">
        <select className="form-control2 pokerwatch-team-filet-select " style={{ height: '36px', border: '1px solid #D1D1D1', borderRadius: '4px' }} onChange={handleAssignTeam} value={updatedSubTeam ? updatedSubTeam : currentSubTeamObj.teamName ? currentSubTeamObj.teamName : 'select'}>
            <option value='select'>Select Team</option>
            {options}
        </select>
    </div>

}
const CoachHeaderDetails = props => {
    const { NumberFormatter, currentSubTeamObj, subMenuEnable, enableComponent, openDialogBox, selectedData, statsUpdate, isCoach } = props;
    let teamData = currentSubTeamObj;
    //console.log('props', props);
    return (<div>
        <Grid container spacing={24} style={{
            marginTop: '20px',
            width: '100%',
            marginLeft: '0px',
            paddingLeft: '0px'
        }}>
            <Grid item xs={9}>
                <Grid container spacing={24} >

                    <Grid item xs style={{ marginTop: '0px', padding: '0px' }}>
                        {/* <i className="fa fa-lg fa-filter" style={{ marginRight: '10px' }}></i> */}
                        <span className="pokerwatch-coach-stable-name">{teamData !== undefined ? teamData.teamName + ' - ' : 'NA'}<span style={{ fontWeight: '400' }}>{' Coach: '}  {teamData !== undefined ? teamData.coachName : ''}</span></span><br />
                    </Grid>
                </Grid>
                <Grid container spacing={24} style={{ marginTop: '8px' }}>
                    <Grid item xs>
                        <div className="pokerwatch-team-stats-details">
                            <div>Games Played: {teamData !== undefined ? NumberFormatter(teamData.noOfGames) : 0}</div>
                            <div>
                                P&L: {(teamData !== undefined && teamData.profitOrLoss > 0) ? "+" : ""}{teamData !== undefined ? NumberFormatter(teamData.profitOrLoss) : 0}
                            </div>
                            <div>Rake: {teamData !== undefined ? NumberFormatter(teamData.totalRake) : 0}</div>
                            <div>Win Rate: {teamData !== undefined ? NumberFormatter(teamData.winRate) : 'winRate'} </div>
                            <div>EV: {teamData !== undefined ? NumberFormatter(teamData.ev) : 'ev'}</div>
                            <div>EV Diff: {teamData !== undefined ? NumberFormatter(teamData.evDiff) : 'evDiff'}</div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
            {!isCoach ?

                <Grid item xs={3} style={{ paddingRight: '0px' }}>

                    {selectedData && selectedData.length > 0 ? <div className="pokerwatch-coach-icons"> <span>
                        <i className="fa fa-lg fa-user-times" onClick={(e) => openDialogBox('deletePlayer')} ></i>

                        <i className="fa fa-chart-bar fa-lg chart-bar-icon" onClick={() => enableComponent('statsUpdate', true)}></i>

                        <i onClick={(e) => openDialogBox('assingPlayer')}> <img src={AssignPlayerIcon} alt="Assign Player" height='18px' style={{ marginRight: '2rem', marginTop: '-4px' }} /></i>
                        <i className="fa fa-lg fa-download" data-toggle="modal" data-target="#downloadModal" onClick={() => {
                            let track = {}
                            track.hit_page = 'Stable';
                            track.hit_type = 'StableDownloadHands';
                            track.hit_attribute1 = props.teamData ? props.teamData.teamName : props.teamData.name;
                            saveActivity(track);
                            enableComponent('', false)
                        }}
                        ></i></span>
                        {statsUpdate ? <div className="stats-update-div" style={{ marginLeft: '-3.2rem' }} >

                            <button className="stats-button-on-off" onClick={(e) => openDialogBox('disableStats', 'statsUpdate')} style={{ marginBottom: '5px' }}>Stats On</button>

                            <button className="stats-button-on-off" onClick={(e) => openDialogBox('enableStats', 'statsUpdate')}>Stats Off</button>

                        </div> : ''}
                    </div> : ''}

                    <ClickAwayListener onClickAway={() => subMenuEnable ? enableComponent('', false) : ''}>
                        <div style={{ display: 'inline' }}><button className='pw-clickmore-no-select-mobile' style={{ marginTop: selectedData && selectedData.length > 0 ? '-5.2rem' : '-10px' }} onClick={() => enableComponent('subMenuEnable', true)} ><i className="fa fa-lg fa-ellipsis-h pw-more-enable-icon" ></i></button>
                            {subMenuEnable ?

                                <div className="pw-team-body-menu" data-e2e="menu-dot" style={{ marginLeft: '9rem', zIndex: '130', marginTop: selectedData && selectedData.length > 0 ? '-2rem' : '2rem', height: '15rem' }} >

                                    <button onClick={e => openDialogBox('editTeam', 'subMenuEnable')} > Edit Team Name</button>

                                    <button onClick={e => openDialogBox('changeCoach', 'subMenuEnable')} > Change Coach </button>

                                    <button onClick={e => openDialogBox('addPlayer', 'subMenuEnable')}> Add Stable users </button>

                                    <button onClick={e => openDialogBox('deleteTeam', 'subMenuEnable')}> Delete Team </button>
                                </div>
                                : ''}
                        </div>
                    </ClickAwayListener>
                </Grid>
                : ''}

        </Grid>

    </div>
    )
}



const AddPlayerToSubTeam = props => {
    //console.log('AddUser Props', props);
    const { onFilter, handleShowPlayers, showStatus, selectedPlayers, handleSelectPlayer } = props;

    let { filterPlayerList } = props;
    filterPlayerList = showStatus ? selectedPlayers : filterPlayerList;
    return <div>
        <input className="pw-search-player" style={{ width: window.innerWidth <= 1024 ? '100%' : '432px' }} data-e2e="player-name" type="text" placeholder="Search Players account name " data-e2e="add-users-to-team"
            onChange={onFilter} /><i className="fa fa-search" style={{ fontSize: '18px', color: '#CCCCCC', marginLeft: '-4rem' }}></i>
        {selectedPlayers && selectedPlayers.length > 0 ? <span onClick={handleShowPlayers} className='show-selected-players-span'> {!showStatus ? 'See Selected (' + selectedPlayers.length + ')' : 'See All'}</span> : <hr style={{marginTop:window.innerWidth<=1024?'41px':'29.5px',marginBottom:'0rem'}}></hr>}
        <div className="pw-added-players" id="pw-added-players2" style={{
            width: window.innerWidth <= 1024 ? '100%' : '432px',
            marginTop:'0rem',
            paddingTop: window.innerWidth <= 1024 ? '2rem':'3rem',

        }} >
            {filterPlayerList !== undefined ? filterPlayerList.map((r, index) => (
                <div className='pw-added-players-text' key={index}>

                    <span>{r}</span>
                    {selectedPlayers.includes(r) ?
                        <i className="fa fa-lg fa-times-circle"
                            onClick={(event) => handleSelectPlayer(selectedPlayers.includes(r), r)}
                            style={{ 'color': '#E8490D', fontSize: '20px', float: 'right' }}></i> : <i className="fa fa-lg fa-plus-circle"
                                onClick={(event) => handleSelectPlayer(selectedPlayers.includes(r), r)}
                                style={{ 'color': '#CCCCCC', fontSize: '20px', float: 'right' }}></i>}
                    {/* <Checkbox style={selectedPlayers.includes(r) ? { height: '15px', width: '15px', fill: '#red' } : { height: '15px', width: '15px', fill: '#DFDFDF' }}
                        checked={selectedPlayers.includes(r)}
                       
                        checkedIcon={<CheckedIcon style={{ fill: "red" }} />}
                        style={{ float: 'right', width: '30px' ,marginTop:'-15px'}}
                    /> */}
                </div>
            )) : ''}
        </div>

    </div>
}
const AddPlayerToStable = props => {
    const { playerNameData, handlePlayerSearch, players, addPlayerToList } = props;
}
const AddUser = props => {
    //console.log('AddUser Props', props);
    const { playerNameData, handlePlayerSearch, players, addPlayerToList } = props;
    return <div>

        <input className="pw-search-player" data-e2e="player-name" type="text" placeholder="Search for partypoker user(s) " data-e2e="add-users-to-team"
            onChange={event => handlePlayerSearch(event)} /> <i className="fa fa-lg fa-plus-circle add-player-circle" style={{ 'color': playerNameData && playerNameData.length !== 0 ? '#E8490D' : '#CCCCCC' }}></i>
        {playerNameData && playerNameData.length !== 0 ? <PlayerSuggestions results={playerNameData} actionPerform={addPlayerToList} players={players} styles={{ marginTop: '0rem', width: window.innerWidth < 768 ? '90%' : window.innerWidth <= 1024 ? '95%' : '35rem' }} /> : ''}
        <div className="pw-added-players" id="pw-added-players">
            {players !== undefined ? players.map((r, _id) => (
                <div key = {_id} className='pw-added-players-text' >
                    <span>{r}</span>  <i className="fa fa-lg fa-times-circle" style={{ cursor: 'pointer', color: '#9B9B9B', float: 'right', marginRight: '2rem' }} onClick={e => addPlayerToList(e, r)}></i>
                </div>
            )) : ''}
        </div>

    </div>
}

const CoachTeamDetails = props => {
    const { teamTableDetails, teamTableData, openDialogBox, isNextAvailable, onVisibilityChange, currentSubTeamObj, filterEnable } = props
    //console.log('currentSubTeamObj',currentSubTeamObj.noOfPlayers)
    return <div>
        <div className="coach-team-div" style={filterEnable ? { marginTop: "7.5rem", top: "37rem" } : {}}>
            <CoachHeaderDetails {...props}>
            </CoachHeaderDetails>
        </div>
        <div style={{ marginTop: '-4rem', paddingTop: '1rem', minHeight: '50rem' }}>
            {teamTableDetails}
            <VisibilitySensor onChange={(isVisible) => onVisibilityChange(isVisible, 'team')}>
                <div className='pokerwatch-team-loading'>
                    {isNextAvailable ? <i className="fa fa-sync fa-lg fa-spin"></i> : ''}
                </div>
            </VisibilitySensor>
            {teamTableData && teamTableData.length > 0 ? '' : currentSubTeamObj && currentSubTeamObj.noOfPlayers > 0 ? <NoActivity customStyle={{ marginTop: '20rem' }} /> : <div className='user-icon-div' style={{ paddingTop: '8rem', marginTop: '25rem' }}><img src={UserIcon} alt="playersCreation" style={{ width: '183px', marginLeft: '40rem', marginTop: '-40rem' }} onClick={e => openDialogBox('addPlayer')} /><h1 style={{ marginTop: '-13rem' }} >Add Players</h1></div>}
        </div>
    </div>
}
const CoachMobileView = (props) => {
    const { currentSubTeamObj, selectedData, enableComponent, coachInfo, NumberFormatter, currentSubTeam } = props;
    let teamData = currentSubTeamObj;
    let stableNameLength = teamData.coachName.length + teamData.teamName.length
    //console.log('stableNameLength',stableNameLength,teamData)
    return <Grid container spacing={24} style={{ marginTop: '1rem', marginBottom: '-2rem', backgroundColor:'#F6F6F6',height:'79px',paddingTop:'20px'}}>
        <Grid item xs={10} style={{ marginTop: '0px', padding: '20px', paddingTop: '0px' }}>

            <span className="pokerwatch-coach-stable-name" style={{ display: ((window.innerWidth <= 320 && stableNameLength > 17) || (window.innerWidth <= 375 && stableNameLength > 23) || (window.innerWidth <= 425 && stableNameLength > 27) || stableNameLength > 30) ? 'block' : 'inline', height: '25px' }}>{teamData !== undefined ? teamData.teamName + ' - ' : 'NA'}</span>
            <span style={{ fontWeight: '400' }}>{' Coach: '}  {teamData !== undefined ? teamData.coachName : ''}</span>

            <ClickAwayListener onClickAway={() => coachInfo ? enableComponent('', false) : ''}>
                <div style={{ display: 'inline', marginLeft: '5px' }}>
                    <button className='pw-info-mobile' onClick={() => enableComponent('coachInfo')}><i className="fa fa-lg fa-info-circle"></i></button>
                    {coachInfo && <div className="owner-info-div" style={{ marginTop: '0px', marginLeft: '4rem', height: '208px' }}>
                        {/* <span style={{fontWeight:'600'}}>Coach : {teamData.coachName}</span> */}
                        <span>Games Played: {teamData !== undefined ? NumberFormatter(teamData.noOfGames) : 0}</span>
                        <span>inline
                            P&L: {(teamData !== undefined && teamData.profitOrLoss > 0) ? "+" : ""}{teamData !== undefined ? NumberFormatter(teamData.profitOrLoss) : 0}
                        </span>
                        <span>Rake: {teamData !== undefined ? NumberFormatter(teamData.totalRake) : 0}</span>
                        <span>Win Rate: {teamData !== undefined ? NumberFormatter(teamData.winRate) : 'winRate'} </span>
                        <span>Win Rate Adj: {teamData !== undefined ? NumberFormatter(teamData.winRate) : 'winRate'} </span>
                        <span>EV Adj: {teamData !== undefined ? NumberFormatter(teamData.ev) : 'ev'}</span>
                        <span>EV Adj Diff: {teamData !== undefined ? NumberFormatter(teamData.evDiff) : 'evDiff'}</span>
                    </div>}</div>
            </ClickAwayListener>
            {window.innerWidth >= 768 ? <Grid container spacing={24} >
                <Grid item xs>
                    <div className="pokerwatch-team-stats-details">
                        <span>Games Played: {teamData !== undefined ? NumberFormatter(teamData.noOfGames) : 0}</span>
                        <span>
                            P&L: {(teamData !== undefined && teamData.profitOrLoss > 0) ? "+" : ""}{teamData !== undefined ? NumberFormatter(teamData.profitOrLoss) : 0}
                        </span>
                        <span>Rake: {teamData !== undefined ? NumberFormatter(teamData.totalRake) : 0}</span>
                        <span>Win Rate: {teamData !== undefined ? NumberFormatter(teamData.winRate) : 'winRate'} </span>
                        <span>EV: {teamData !== undefined ? NumberFormatter(teamData.ev) : 'ev'}</span>
                        <span>EV Diff: {teamData !== undefined ? NumberFormatter(teamData.evDiff) : 'evDiff'}</span>
                    </div>
                </Grid>
            </Grid> : ''}
        </Grid>

        <Grid item xs={2} >
            <button className={selectedData && selectedData.length > 0 ? 'pw-clickmore-select-mobile' : 'pw-clickmore-no-select-mobile'} style={{ marginTop: ((window.innerWidth <= 320 && stableNameLength > 17) || stableNameLength > 30) ? '-5px' : '-12px', marginRight: '4px' ,backgroundColor:selectedData && selectedData.length > 0?'#E8490D':'#F6F6F6'}} onClick={() => enableComponent('subMenuEnable')}><i className="fa fa-lg fa-ellipsis-h pw-more-enable-icon" data-e2e="menu-dot"></i></button>
        </Grid>

    </Grid>
}

const MobilePlayerGrid = (props) => {
    const { stateChange, teamTableData, NumberFormatter, onVisibilityChange, handleCheckbox, selectedData, currentSubTeam, openDialogBox, isNextAvailable, teamData } = props
    //console.log('selectedData',selectedData,onVisibilityChange)
    return <div>
        {currentSubTeam && <CoachMobileView {...props} />}
        {teamTableData && teamTableData.map((item, key = { item }) => {
            return (

                <Grid container spacing={24} style={{ marginTop: '2rem', borderBottom: '1px solid #E6E6E6', width: '100%', marginLeft: '0px', marginRight: '0px' }}>

                    <Grid item xs={9} onClick={e => stateChange(e, item)}>
                        <div className='stable-name-div' >
                            {item.statsVisible ? <i className="fa fa-chart-bar chart-bar-icon" style={{ width: '0px' }}></i> : ''}
                            <span className={item.statsVisible ? "pw-team-teamname-mobile-stats" : "pw-team-teamname-mobile"} style={{ width: '80%' }} >{item.playerName !== undefined ? item.playerName : item}</span>
                        </div>
                        <span className='pw-team-mobile-stats'>
                            <span>P&L {item.playerName !== undefined ? NumberFormatter(item.profitOrLoss) : 0} | </span>
                            <span>RAKE:{item.playerName !== undefined ? NumberFormatter(item.totalRake) : 0} | </span>
                            <span>WIN RATE: {item.playerName !== undefined ? NumberFormatter(item.winRate) : 0} | </span>
                            <span>EV: {item.playerName !== undefined ? NumberFormatter(item.ev) : 0}  | </span>
                            <span>EV Diff: {item.playerName !== undefined ? NumberFormatter(item.evDiff) : 0}  | </span>
                            <span>GAMES: {item.playerName !== undefined ? item.noOfGames : 0} </span>
                        </span>
                    </Grid>
                    <Grid item xs={3} style={{ paddingTop: '10px' }}>
                        <Checkbox
                            style={{ width: 20, height: 20, float: 'right' }}
                            checked={selectedData.includes(item) ? true : false}
                            onChange={(event) => { handleCheckbox(event, item) }}
                            icon={<CheckBoxOutlineBlankIcon style={{
                                height: '15px', width: '15px', border: '1px solid #858585',
                                borderRadius: '2px',
                                backgroundColor: '#FFFFFF',
                                boxShadow: '0 2px 4px 0 rgba(0,0,0,0.16)'
                            }} />}
                            checkedIcon={<CheckedIcon style={{ fill: "red" }} />} />


                    </Grid>
                </Grid>


            )
        })}
        {onVisibilityChange && <VisibilitySensor onChange={(isVisible) => onVisibilityChange(isVisible, 'team')} scrollCheck={true}>
            <div className='pokerwatch-team-loading'>
                {isNextAvailable ? <i className="fa fa-sync fa-lg fa-spin"></i> : ''}
            </div>
        </VisibilitySensor>}
        {teamTableData && teamTableData.length > 0 ? '' : teamData && teamData.noOfPlayers > 0 ? <NoActivity /> : <div className='mobile-user-icon-div'><img src={UserIcon} alt="playersCreation" style={{ width: '17.2rem' }} onClick={e => openDialogBox(currentSubTeam ? 'addPlayer' : 'addUser', currentSubTeam ? 'addPlayer' : 'addUser')} /><h1 >Add Players</h1></div>}

    </div>
}
const MobileHeader = (props) => {
    const { NumberFormatter, ownerInfo, teamData, bussinessOwnerStatus, routeChange, selectedData, enableComponent, currentSubTeam } = props;
    //console.log('ownenrInfo',ownerInfo);
    return <nav className="navbar-fixed-top fixed-top-2" style={{minHeight:'55px'}}>
        <Grid container spacing={24} style={{
            marginTop: window.innerWidth >= 768 ? '0px' : ''
        }}>
            <Grid item xs={11} style={{ paddingLeft: '0px', paddingTop: window.innerWidth >= 768 ? '9px' : currentSubTeam ? '20.5' : '31.5px' }}>
                <div className="go-back-arrow-div" style={{ marginTop: window.innerWidth >= 768 || currentSubTeam ? '8px' : '0.5px' }}>
                    {bussinessOwnerStatus ? <i className="fa fa-arrow-left" onClick={() => routeChange()} data-e2e="go-back-left-arrow" ></i> : ''}
                </div>
                <div className="stable-name-header-div">


                    {window.innerWidth >= 768 ? <span className="pokerwatch-admin-stable-name">{teamData !== undefined ? teamData.teamName ? teamData.teamName + ' - ' : teamData.name + ' - ' : 'NA'}<span style={{ fontWeight: '400' }}>{' Stable Owner: '}  {teamData !== undefined ? teamData.ownerName : ''}</span></span>
                        : <span className="pokerwatch-admin-stable-name">{teamData !== undefined ? teamData.teamName : 'NA'}</span>}
                    <ClickAwayListener onClickAway={() => ownerInfo ? enableComponent('', false) : ''}>
                        <div style={{ display: 'inline' }}>
                            {currentSubTeam ? <div style={{ marginLeft: '2.4rem', marginTop: '-1px' }}><i className="fa fa-filter fa-xs" style={{ marginRight: '0px', color: 'red' }}> <span style={{ fontFamily: 'Roboto', fontSize: '12px' }}>Team Filter Applied</span></i> </div> : <button className='pw-info-mobile' onClick={() => enableComponent('ownerInfo')}><i className="fa fa-lg fa-info-circle"></i></button>}

                            {ownerInfo && <div className="owner-info-div">
                                <span style={{ fontWeight: '600' }}>Stable Owner: {teamData.ownerName}</span>
                                <span>Games Played: {teamData !== undefined ? NumberFormatter(teamData.noOfGames) : 0}</span>
                                <span>
                                    P&L: {(teamData !== undefined && teamData.profitOrLoss > 0) ? "+" : ""}{teamData !== undefined ? NumberFormatter(teamData.profitOrLoss) : 0}
                                </span>
                                <span>Rake: {teamData !== undefined ? NumberFormatter(teamData.totalRake) : 0}</span>
                                <span>Win Rate: {teamData !== undefined ? NumberFormatter(teamData.winRate) : 'winRate'} </span>
                                <span>Win Rate Adj: {teamData !== undefined ? NumberFormatter(teamData.winRate) : 'winRate'} </span>
                                <span>EV Adj: {teamData !== undefined ? NumberFormatter(teamData.ev) : 'ev'}</span>
                                <span>EV Adj Diff: {teamData !== undefined ? NumberFormatter(teamData.evDiff) : 'evDiff'}</span>
                            </div>}</div>
                    </ClickAwayListener>

                </div>

                {window.innerWidth >= 768 && !currentSubTeam ? <Grid container spacing={24} >
                    <Grid item xs>
                        <div className="pokerwatch-team-stats-details" style={{ marginTop: '5px', marginLeft: '24px' }}>
                            <span>Games Played: {teamData !== undefined ? NumberFormatter(teamData.noOfGames) : 0}</span>
                            <span>
                                P&L: {(teamData !== undefined && teamData.profitOrLoss > 0) ? "+" : ""}{teamData !== undefined ? NumberFormatter(teamData.profitOrLoss) : 0}
                            </span>
                            <span>Rake: {teamData !== undefined ? NumberFormatter(teamData.totalRake) : 0}</span>
                            <span>Win Rate: {teamData !== undefined ? NumberFormatter(teamData.winRate) : 'winRate'} </span>
                            <span>EV: {teamData !== undefined ? NumberFormatter(teamData.ev) : 'ev'}</span>
                            <span>EV Diff: {teamData !== undefined ? NumberFormatter(teamData.evDiff) : 'evDiff'}</span>
                        </div>
                    </Grid>
                </Grid> : ''}
            </Grid>
            <Grid item xs={1}><br />
                <button className={selectedData && selectedData.length > 0 && currentSubTeam === '' ? 'pw-clickmore-select-mobile' : 'pw-clickmore-no-select-mobile'} onClick={() => enableComponent('moreEnable')} style={{ marginTop: window.innerWidth >= 768 ? '-17px' : '-6px' }}><i className="fa fa-lg fa-ellipsis-h pw-more-enable-icon" data-e2e="menu-dot"></i></button>
            </Grid>

        </Grid>

    </nav>
}

const CustomisedDiv = (props) => {
    const { dialogContent, addPlayerToList } = props
    const { isDialogOpen, title, dataType, cancelDialog,isButtonsShow, newButton,actionPerform, errorMessage, isError, createButtonLable, createButtonStyleName } = dialogContent;
    if (!isDialogOpen) {
        return ''
    }
    return <div className="customised-div">
        <span className="pw-filter-mobile-setting-span"> {title}</span> <i className="fa fa-lg fa-times" style={{ float: 'right', marginRight: '1rem' }} onClick={e => cancelDialog(e, { dataType })}></i>
        {dialogContent.dataType === 'addUser' ? <AddUser {...props} actionPerform={addPlayerToList} /> : dialogContent.dataType === 'ownerCreationModal' ?
            <CreateOwner {...props} type={'owner'} actionPerform={addPlayerToList}></CreateOwner> : dialogContent.dataType === 'createNewTeam' ?
                <CreateTeam {...props} actionPerform={addPlayerToList}></CreateTeam> : dialogContent.dataType === 'changeOwner' ?
                    <ChangeOwner {...props} actionPerform={addPlayerToList}></ChangeOwner> : dialogContent.dataType === 'changeCoach' ?
                        <ChangeCoach {...props} actionPerform={addPlayerToList}></ChangeCoach> : dialogContent.dataType === 'editTeam' ?
                            <UpdateTeam {...props} actionPerform={addPlayerToList}></UpdateTeam> : dialogContent.dataType === 'addPlayer' ?
                                <AddPlayerToSubTeam  {...props} actionPerform={addPlayerToList}></AddPlayerToSubTeam> : dialogContent.dataType === 'deletePlayer' ?
                                    <p className="pokerwatch-dialog-common">Would you like to remove selected player(s) from the team?</p> : dialogContent.dataType === 'assingPlayer' ?
                                        <AssignPlayerToTeam {...props}></AssignPlayerToTeam> : dialogContent.dataType === 'coachCreationModal' || dialogContent.dataType === 'coachCreationModalUpdate' ?
                                            <CreateOwner {...props} actionPerform={addPlayerToList}></CreateOwner> : dialogContent.dataType === 'deleteTeam' ?
                                                <p className="pokerwatch-dialog-common">Would you like to delete selected team ?</p> : dialogContent.dataType === 'enableStats' ?
                                                    <p className="pokerwatch-dialog-common">Would you like to make visible P&L, Rake and EV for the selected players ?</p> : dialogContent.dataType === 'disableStats' ?
                                                        <p className="pokerwatch-dialog-common">Would you like to hide P&L, Rake and EV for the selected players ?</p> : ''
        }
        <span style={{ color: 'red' }}>{errorMessage} </span>
        {isButtonsShow && <div className="poker-watch-create-team-buttons-div">
          <button className="poker-watch-cancel-team-button"data-e2e="team-cancel" onClick={e => cancelDialog(e, {dataType})} >Cancel</button>
          <button className={createButtonStyleName?createButtonStyleName:"poker-watch-create-team-button-not-active"} data-e2e="team-cancel" onClick={isError?'':actionPerform}>{createButtonLable?createButtonLable:'create'}</button>
      </div> }
        {newButton ? <button className={createButtonStyleName?createButtonStyleName:"poker-watch-new-button-not-active"} onClick={isError?'':actionPerform}>{createButtonLable?createButtonLable:'create'}</button>:''}
    </div>
}
const MobileViewTeam = (props) => {
    const { moreEnable, dialogContent, subMenuEnable } = props;

    return <div style={{ backgroundColor: 'white' }}>
        {moreEnable || subMenuEnable ? <MobileStatsDetails {...props} ></MobileStatsDetails> :
            dialogContent && dialogContent.isDialogOpen ? <CustomisedDiv {...props}>
            </CustomisedDiv>
                : <div><MobileHeader {...props}></MobileHeader>
                    <MobilePlayerGrid  {...props}></MobilePlayerGrid></div>
        }

    </div>
}
class PokerwatchTeamBody extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            pwTeamBody: props.data,
            dialogContent: { 'isDialogOpen': false },
            pokerwatchConfigObj: { ...props }
        };
    }
    componentDidMount() {

        const { pokerwatchConfigObj } = this.state;
        //console.log('pokerwatchConfigObj', pokerwatchConfigObj);
        pokerwatchConfigObj['openDialogBox'] = this.openDialogBox;
        //console.log('this.props', this.props);
        this.setState({
            pokerwatchConfigObj
        })
    }
    //  componentWillUnmount = () => {
    //      //console.log('handleTeamAndPlayer',this.props)
    //         this.props.handleTeamAndPlayer();
    //   }

    render() {


        return <MediaQuery minWidth={1025}>
            {(matches) => {
                if (matches) {
                    const { filterEnable, onVisibilityChange, isNextAvailable, teamTableData, currentSubTeam, stateChange, selectedData, handleCheck, handleSort, sortOrder, bussinessOwnerStatus, routeChange, openDialogBox, teamData } = this.props;
                    const headers = [
                        { label: 'Player Name', id: 'playerName', style: { padding: '0px', width: '150px' }, colSpan: "4", sortEnabled: true, handleSort, sortOrder, onClick: stateChange, statsVisibleIcon: true },
                        { label: 'Games', id: 'noOfGames', style: { padding: '0px' }, sortEnabled: true, handleSort, sortOrder },
                        { label: 'Rake', id: 'totalRake', style: { padding: '0px' }, sortEnabled: true, handleSort, sortOrder },
                        { label: 'Win Rate', id: 'winRate', style: { padding: '0px' }, sortEnabled: true, handleSort, sortOrder },
                        { label: 'EV', id: 'ev', style: { padding: '0px' }, sortEnabled: true, handleSort, sortOrder },
                        { label: 'EV Diff', id: 'evDiff', style: { padding: '0px' }, sortEnabled: true, handleSort, sortOrder },
                        { label: 'P&L', id: 'profitOrLoss', style: { padding: '0px' }, sortEnabled: true, handleSort, sortOrder },
                    ]


                    //console.log('In Pokerwatch-team-body', teamData);
                    // let border =teamTableData && teamTableData.length>0 ? '':undefined
                    let tableStyle = {
                        thead: {
                            height: '43px',
                            background: '#F6F6F6',
                            // border: '1px solid #E8E8E8',
                            // borderLeft: '0px',
                            // borderRight: '0px',
                            position: 'sticky',
                            top: '15rem',
                            zIndex:160
                        },
                        tbody: {
                            height: '72px',
                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 1px 0px',

                        },
                        root: {
                            width: '100%',
                            marginTop: '23px',
                            // overflowX: 'auto',
                            paddingLeft: '0px !important',
                            paddingRight: '0px !important',
                            fontFamily: 'Roboto Medium',
                            boxShadow: '0px 0px 0px 0px',
                            position: 'sticky',
                            top: '18.5rem'
                        },
                        headerCell: {
                            paddingLeft: '15px',
                            width: '0px',
                            position: 'sticky',
                            top: '18rem',
                            zIndexndex: '150',
                            background: '#F6F6F6',
                            border: '1px solid #E8E8E8',
                            borderLeft: '0px',
                            borderRight: '0px',
                            zIndex: '150'
                        },

                        cell: {
                            padding: '0px',
                            fontSize: '16px',
                            color: '#000000',
                            fontFamily: 'Roboto-Medium'

                        }
                    }
                    if (currentSubTeam) {
                        tableStyle['headerCell']['borderTop'] = '1px solid #A0A0A0';
                        tableStyle['headerCell']['borderBottom'] = '1px solid #A0A0A0';
                        tableStyle['root']['boxShadow'] = 'none';
                        tableStyle['root']['top'] = '28.9rem';
                        tableStyle['headerCell']['top'] = '28.9rem';

                    }
                    if (filterEnable) {
                        tableStyle['headerCell']['top'] = '37.4rem';
                        if (currentSubTeam) {
                            tableStyle['root']['top'] = '48.9rem';
                            tableStyle['headerCell']['top'] = '47.9rem';
                        }
                        tableStyle['root']['top'] = '34rem';

                    }
                    let teamTableDetails = <DataTable showCheckBox={true} onCheck={handleCheck} headers={headers} rows={teamTableData ? teamTableData : []} styles={tableStyle} selectedRows={selectedData} />
                    return <div>

                        {bussinessOwnerStatus ? <div style={{ position: 'fixed', top: '0rem', zIndex: 1300 }} ><button style={{ width: '20rem', background: 'transparent', border: '0px', height: '5rem' }} onClick={() => routeChange('/pokerwatch')}></button></div> : ''}
                        <div>

                            <nav className="navbar-fixed-top fixed-top-2" style={filterEnable || currentSubTeam ? { boxShadow: "0px 5px 5px -5px rgba(0,0,0,0.17)" } : {}}>

                                <HeaderDetails {...this.props}></HeaderDetails>

                            </nav>
                            {filterEnable ? <FilterGrid {...this.props} ></FilterGrid> : ''}
                        </div>

                        {currentSubTeam ? <CoachTeamDetails {...this.props} teamTableDetails={teamTableDetails} teamTableData={teamTableData} ></CoachTeamDetails>
                            : <div style={{ marginTop: filterEnable ? '7.6rem' : '13.3rem', minHeight: teamTableData && teamTableData.length > 0 ? '50rem' : '0rem', background: 'white', marginLeft: '5px', position: 'sticky', top: '18.3rem' }}>{teamTableDetails} {teamTableData && teamTableData.length > 0 ?
                                <VisibilitySensor onChange={(isVisible) => onVisibilityChange(isVisible, 'team')} scrollCheck={true}>
                                    <div className='pokerwatch-team-loading'>
                                        {isNextAvailable ? <i className="fa fa-sync fa-lg fa-spin"></i> : ''}
                                    </div>
                                </VisibilitySensor>
                                : teamData && teamData.noOfPlayers > 0 ? <NoActivity /> : <div className='user-icon-div' ><img src={UserIcon} alt="playersCreation" style={{ width: '183px', cursor: 'pointer', marginLeft: '40rem', marginTop: '-5rem' }} onClick={e => openDialogBox('addUser')} />
                                    <h1 >Add Players</h1></div>}</div>}



                    </div>
                }
                else {
                    return <MobileViewTeam {...this.props} />
                }
            }
            }</MediaQuery>
    }
}

export default PokerwatchTeamBody;


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/Pokerwatch-team-body.js
 **/